import { render, staticRenderFns } from "./addCadastralOvamCustomerModal.vue?vue&type=template&id=7542b6d3&scoped=true"
import script from "./addCadastralOvamCustomerModal.vue?vue&type=script&lang=js"
export * from "./addCadastralOvamCustomerModal.vue?vue&type=script&lang=js"
import style0 from "./addCadastralOvamCustomerModal.vue?vue&type=style&index=0&id=7542b6d3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7542b6d3",
  null
  
)

export default component.exports